import { render, staticRenderFns } from "./ProfileUserImageForm.vue?vue&type=template&id=c8f87f8c&"
import script from "./ProfileUserImageForm.vue?vue&type=script&lang=js&"
export * from "./ProfileUserImageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports